import React from "react";
import {
  Users,
  Building2,
  UserCheck,
  Calendar,
  Coins,
  MessageSquare,
  MapPin,
  Award,
} from "lucide-react";

const stats = [
  {
    icon: <Users className="w-10 h-10 text-[#003153]" />,
    title: "10,000+ customers",
    desc: "purchased a property from Nova Capital Group in the UAE",
  },
  {
    icon: <Building2 className="w-10 h-10 text-[#003153]" />,
    title: "1000+ properties",
    desc: "sold, rented, and leased throughout the UAE",
  },
  {
    icon: <UserCheck className="w-10 h-10 text-[#003153]" />,
    title: "50+ top performing agents",
    desc: "who specialize in your target area",
  },
  {
    icon: <Calendar className="w-10 h-10 text-[#003153]" />,
    title: "15+ years",
    desc: "of experience",
  },
  {
    icon: <Coins className="w-10 h-10 text-[#003153]" />,
    title: "AED 1 Billion",
    desc: "total amount of real estate sold by us in 2025",
  },
  {
    icon: <MessageSquare className="w-10 h-10 text-[#003153]" />,
    title: "40+ languages",
    desc: "spoken by our agents and team",
  },
  {
    icon: <MapPin className="w-10 h-10 text-[#003153]" />,
    title: "05 Offices",
    desc: "including Dubai, Abu Dhabi, and Sharjah",
  },
  {
    icon: <Award className="w-10 h-10 text-[#003153]" />,
    title: "Top Selling Partner Partner",
    desc: "with the leading UAE developers",
  },
];

const AboutUs = () => {
  return (
    <section className="bg-blue-50 lg:py-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <h2 className="text-3xl md:text-4xl font-bold text-[#000000] mb-6">
          About Us
        </h2>
        <p className="text-black text-md md:text-lg mb-8 leading-relaxed max-w-4xl mx-auto">
          At Nova Capital Real Estate, we specialize in connecting discerning
          clients with the finest properties Dubai has to offer. Whether you’re
          looking to buy, sell, or invest, our team of experienced professionals
          is dedicated to providing exceptional service tailored to your unique
          needs.
        </p>

        {/* Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((item, index) => (
            <div
              key={index}
              className="bg-white border rounded-xl shadow-sm p-6 flex flex-col items-center text-center hover:shadow-md transition-all"
            >
              <div className="mb-4">{item.icon}</div>
              <h3 className="font-semibold text-black mb-2 text-lg">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
